export default {
  timetable: "Emploi du temps",
  yourCourses: "Vos cours",
  "There are no events on this day.": "Il n'y aucun évènement ce jour là",
  Today: "Aujourd'hui",
  Month: "Mois",
  Week: "Semaine",
  Day: "Jour",
  Year: "Année",
  More: "Plus",
  "Application for authorization of exceptional absence": "Demande d'autorisation d'absence exceptionnelle",
  "Add a new event": "Ajouter un nouvel évènement",
};
